import { put } from 'redux-saga/effects'
import { getEventById } from '../../../actions/influencerActions'

// @ts-ignore
function* onAcceptNewTrack(entity) {
  yield put.resolve(getEventById(entity.payload.eventId))
}

export default onAcceptNewTrack
